import { useEffect, useRef } from "react";
import type { AnimationItem } from "lottie-web";
import { ASSETS } from "@zkresistor/client";

export function MtongaFlag() {
  const container = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    let cancelled = false;
    let animation: AnimationItem | null = null;
    void Promise.all([
      import("lottie-web/build/player/lottie_light"),
      fetch(ASSETS.mtonga).then((response) => {
        if (!response.ok) throw new Error(`MTONGA animation returned ${response.status}`);
        return response.json() as Promise<unknown>;
      }),
    ]).then(([module, animationData]) => {
      if (cancelled || container.current === null) return;
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      animation = module.default.loadAnimation({
        container: container.current,
        renderer: "svg",
        loop: !reducedMotion,
        autoplay: !reducedMotion,
        animationData,
      });
      if (reducedMotion) animation.goToAndStop(0, true);
    }).catch(() => undefined);

    return () => {
      cancelled = true;
      animation?.destroy();
    };
  }, []);

  return <span ref={container} className="footer-flag" aria-hidden="true" />;
}
